import React, { useEffect, useRef, useState } from "react";
import { useField } from "formik";

import "./PropListItem.css";

export const PropListItem = ({ index }) => {
    // Binding `isCompleted` using index of todos array
    const [isActiveField, isActiveMeta, isActiveHelpers] = useField({
        name: `PropListItem[${index}].IsActive`,
        type: "checkbox"
    });
    // Binding `content` using index of todos array
    const [contentField, contentMeta, contentHelpers] = useField(
        `PropListItem[${index}].content`
    );
    const [isFocused, setIsFocused] = useState(false);
    const onContentInput = e => {
        contentHelpers.setValue(e.currentTarget.innerText);
    };
    const onContentBlur = () => {
        setIsFocused(false);
        contentHelpers.setTouched(true);
    };
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            // contentRef.current.focus();
        }
    }, []);

    return (
        <div
            className={[
                "PropList-item",
                isFocused && "focused",
                isActiveField.checked && "completed",
                contentMeta.error && contentMeta.touched && "invalid"
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <input
                type="checkbox"
                name={isActiveField.name}
                checked={isActiveField.checked}
                onChange={({ target }) => {
                    isActiveHelpers.setValue(target.checked);
                    // As type=checkbox doesn't call onBlur event
                    isActiveHelpers.setTouched(true);
                }}
            />
            <span
                contentEditable
                ref={contentRef}
                className={"PropListItem-text"}
                onInput={onContentInput}
                onFocus={() => setIsFocused(true)}
                onBlur={onContentBlur}
                dangerouslySetInnerHTML={{ __html: contentMeta.initialValue }}
            >
                {} 
            </span>
        </div>
    );
};